import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import PromotionsManagement from './components/PromotionsManagement';
import LoadingPage from "../../components/Loading";
import PageNotFound from "../PageNotFound";
import ContentHomePageManagement from "./components/ContentHomePageManagement";

const TABS = ['文章管理', '首頁內容',] //'探索社群', '探索社群 - 貼文', '生活服務', 'T.Shop', '私隱條款', '聯絡我們', '常見問題'];

function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();
    const [tab, setTab] = useState(TABS[0])








    return (
        <div className="relative h-full w-full flex flex-col items-start justify-start bg-[#ddd] pb-[16px] gap-[8px]" style={{ overflowY: 'auto' }}>

            {/* <div className='font-[700] p-[16px] bg-[white] rounded-[7px] w-full'>內容管理</div> */}
            <div className="w-full flex flex-row gap-[16px] flex-wrap p-[16px] relative">
                {TABS.map((item, index) =>
                    <div key={item} className="flex flex-row items-center justify-center cursor-pointer z-[2]" style={{ fontWeight: item === tab ? '700' : '400', fontSize: '16px', color: item === tab ? '#0F737E' : '#00000099', padding: '8px 16px', borderBottom: item === tab ? '2px solid #0F737E' : 'none' }} onClick={() => { setTab(item) }}>
                        {item}
                    </div>
                )}
                <div className="absolute top-0 left-0 right-0 bottom-0 z-[1]" style={{ background: 'linear-gradient(180deg, rgba(230, 235, 237, 0.3) 28.5%, #FFFFFF 100%)' }} />
            </div>

            {tab === '文章管理' && <PromotionsManagement />}
            {tab === '首頁內容' && <ContentHomePageManagement />}

            {!['文章管理','首頁內容'].includes(tab) && <PageNotFound/>}


            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)
